import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Avatar,
  Typography,
  CardHeader,
  Divider,
} from "@material-ui/core";
import RingingInIcon from "@material-ui/icons/ArrowForward";
import RingingOutIcon from "@material-ui/icons/ArrowBack";
import LineIcon from "@material-ui/icons/Remove";
import CheckIcon from "@material-ui/icons/Check";
import { makeStyles } from "@material-ui/core/styles";
import { agentStatuses } from "./constants.js";
import TimerComponent from "./TimerComponent.jsx";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useTranslation } from "react-i18next";

var voiceManage = true;

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    backgroundColor: "#1b1c1c",
    // minHeight: "120px",
    height: "106px",
  },
  divider: {
    backgroundColor: "white",
    marginBottom: "5px",
  },
  fabProgress: {
    color: "white",
    position: "absolute",
    top: 0,
    left: 0,
    zIndex: 3,
  },
}));

export default function AgentStateCard(props) {
  const { t } = useTranslation();
  //ringToneObj.src = ringTone1;
  //ringToneObj.loop = true;
  const classes = useStyles();

  //    window.props = props;
  const [timerState, setTimerState] = useState(false);

  useEffect(() => {
    if (
      props.state.AgentState === agentStatuses.Non_Acd_Busy ||
      props.state.AgentState === agentStatuses.ACD_Busy ||
      props.state.AgentState === agentStatuses.ACD_Busy_Callback
    )
      setTimerState(true);

    return () => {
      setTimerState(false);
    };
  }, [props.state.AgentState]);

  // useEffect(() => {
  //     //document.addEventListener(rainbowSDK.telephony.RAINBOW_ONTELEPHONYCALLSTATECHANGED, onTelephonyChangedEvent);
  //     //document.addEventListener(rainbowSDK.telephony.RAINBOW_ONVOIPCALLSTATECHANGED, onTelephonyVoipChangedEvent);
  // },[]);

  // useEffect( () =>{
  //         voiceManage = props.voiceCtrl;
  //         console.log("Voice Control changed to:" + voiceManage + ":" + props.voiceCtrl)
  // },[props.voiceCtrl])

  // const answerCall = () =>
  // {
  //     if(props.state.AgentState===agentStatuses.Ringing_IN_ACD ||props.state.AgentState===agentStatuses.Ringing_IN_ACD_Callback)
  //     props.updateAgentState({...props.state,AgentState:agentStatuses.Custom_Connecting_ACD});
  //     else
  //     props.updateAgentState({...props.state,AgentState:agentStatuses.Custom_Connecting_NonACD});

  //     //rainbowSDK.telephony.answer(callID).then(()=>{});

  // }
  // const hangupCall = () =>
  // {
  //    // props.updateAgentState({...props.state, AgentState:agentStatuses.Custom_HangingUp})
  //     //rainbowSDK.telephony.release(callID).then(()=>{});
  // }
  return (
    <Card raised="true" className={classes.cardRoot}>
      {((props.state.AgentState === agentStatuses.Not_Available ||
        props.state.AgentState === agentStatuses.Temp_Absent) && (
        <CardHeader
          avatar={
            <Avatar
              style={{
                backgroundColor: "red",
                width: "55px",
                height: "55px",
                marginTop: "-10px",
              }}
            >
              <LineIcon />
            </Avatar>
          }
          title={
            <Typography
              id="myAgentState"
              variant="h5"
              style={{ color: "white" }}
            >
              {t("agentstatus.unavailable")}
              <Divider variant="fullWidth" className={classes.divider} />
            </Typography>
          }
          subheader={
            <>
              <Typography variant="body1" style={{ color: "white" }}>
                {props.state.Name === ""
                  ? t("agentstatus.loading")
                  : props.state.Name}
              </Typography>
              <Typography variant="body1" style={{ color: "white" }}>
                {props.displayExtension === ""
                  ? t("agentstatus.loading")
                  : props.displayExtension}
              </Typography>
            </>
          }
        />
      )) ||
        (props.state.AgentState === agentStatuses.Clerical_Work && (
          <CardHeader
            avatar={
              <Avatar
                style={{
                  backgroundColor: "blue",
                  width: "55px",
                  height: "55px",
                  marginTop: "-10px",
                }}
              >
                <LineIcon />
              </Avatar>
            }
            title={
              <Typography
                id="myAgentState"
                variant="h5"
                style={{ color: "white" }}
              >
                {t("agentstatus.preparation")}
                <Divider variant="fullWidth" className={classes.divider} />
              </Typography>
            }
            subheader={
              <>
                <Typography variant="body1" style={{ color: "white" }}>
                  {props.state.Name == null || props.state.Name == ""
                    ? "..."
                    : props.state.Name}
                </Typography>
                <Typography variant="body1" style={{ color: "white" }}>
                  {props.displayExtension}
                </Typography>
              </>
            }
          />
        )) ||
        (props.state.AgentState === agentStatuses.Custom_Connecting_NonACD && (
          <CardHeader
            avatar={
              <Avatar
                style={{
                  backgroundColor: "orange",
                  width: "55px",
                  height: "55px",
                  marginTop: "-10px",
                }}
              >
                <CheckIcon />
              </Avatar>
            }
            title={
              <Typography
                id="myAgentState"
                variant="h5"
                style={{ color: "white" }}
              >
                Connecting...
                <Divider variant="fullWidth" className={classes.divider} />
              </Typography>
            }
            subheader={
              <>
                <Typography variant="body1" style={{ color: "white" }}>
                  Internal
                </Typography>
                <Typography variant="body1" style={{ color: "white" }}>
                  Duration 00:00:00
                </Typography>
              </>
            }
          />
        )) ||
        (props.state.AgentState === agentStatuses.Custom_Connecting_ACD && (
          <CardHeader
            avatar={
              <Avatar
                style={{
                  backgroundColor: "orange",
                  width: "55px",
                  height: "55px",
                  marginTop: "-10px",
                }}
              >
                <CheckIcon />
              </Avatar>
            }
            title={
              <Typography
                id="myAgentState"
                variant="h5"
                style={{ color: "white" }}
              >
                Connecting...
                <Divider variant="fullWidth" className={classes.divider} />
              </Typography>
            }
            subheader={
              <>
                <Typography variant="body1" style={{ color: "white" }}>
                  Connecting...
                </Typography>
                <Typography variant="body1" style={{ color: "white" }}>
                  Duration 00:00:00
                </Typography>
              </>
            }
          />
        )) ||
        (props.state.AgentState === agentStatuses.Custom_HangingUp && (
          <CardHeader
            avatar={
              <Avatar
                style={{
                  backgroundColor: "orange",
                  width: "55px",
                  height: "55px",
                  marginTop: "-10px",
                }}
              >
                <CheckIcon />
                <CircularProgress size={55} className={classes.fabProgress} />
              </Avatar>
            }
            //action ={<React.Fragment><IconButton style={{padding:'10px'}}><Avatar style={{backgroundColor:'grey'}}><CallEndIcon style={{color:'white'}}/></Avatar></IconButton></React.Fragment>}
            title={
              <Typography
                id="myAgentState"
                variant="h5"
                style={{ color: "white" }}
              >
                {t("agentstatus.hangingup")}
                <Divider variant="fullWidth" className={classes.divider} />
              </Typography>
            }
            subheader={
              <>
                <Typography variant="body1" style={{ color: "white" }}>
                  {props.state.Name}
                </Typography>
                <Typography variant="body1" style={{ color: "white" }}>
                  Duration --:--:--
                </Typography>
              </>
            }
          />
        )) ||
        ((props.state.AgentState === agentStatuses.Idle ||
          props.state.AgentState === agentStatuses.Available) && (
          <CardHeader
            avatar={
              <Avatar
                id="myAvatarID"
                style={{
                  backgroundColor: "green",
                  width: "55px",
                  height: "55px",
                  marginTop: "-10px",
                }}
              >
                <CheckIcon />
                {props.circularProgressState && (
                  <CircularProgress size={55} className={classes.fabProgress} />
                )}
              </Avatar>
            }
            title={
              <Typography
                id="myAgentState"
                variant="h5"
                style={{ color: "white" }}
              >
                {t("agentstatus.available")}
                <Divider variant="fullWidth" className={classes.divider} />
              </Typography>
            }
            subheader={
              <>
                <Typography variant="body1" style={{ color: "white" }}>
                  {props.state.Name}
                </Typography>
                <Typography variant="body1" style={{ color: "white" }}>
                  {props.displayExtension}
                </Typography>
              </>
            }
          />
        )) ||
        ((props.state.AgentState === agentStatuses.Ringing_IN_ACD ||
          props.state.AgentState === agentStatuses.Ringing_IN_ACD_Callback) && (
          <CardHeader
            avatar={
              <Avatar
                style={{
                  backgroundColor: "orange",
                  width: "55px",
                  height: "55px",
                  marginTop: "-10px",
                }}
              >
                <RingingInIcon />
              </Avatar>
            }
            title={
              <Typography
                id="myAgentState"
                variant="h5"
                style={{ color: "white" }}
              >
                {t("agentstatus.ringing")}
                <Divider variant="fullWidth" className={classes.divider} />
              </Typography>
            }
            subheader={
              <>
                <Typography variant="body1" style={{ color: "white" }}>
                  {props.groupCR.GroupName == null ||
                  props.groupCR.GroupName == "..." ||
                  props.groupCR.GroupName == ""
                    ? "..."
                    : props.groupCR.GroupName +
                      "," +
                      props.groupCR.CallerNumber}
                </Typography>
                <Typography variant="body1" style={{ color: "white" }}>
                  Duration 00:00:00
                </Typography>
              </>
            }
          />
        )) ||
        ((props.state.AgentState === agentStatuses.Non_Acd_Ringing ||
          props.state.AgentState === agentStatuses.Busy_OutboundCall) && (
          <CardHeader
            avatar={
              <Avatar
                style={{
                  backgroundColor: "orange",
                  width: "55px",
                  height: "55px",
                  marginTop: "-10px",
                }}
              >
                {props.state.Direction === "I" ? (
                  <RingingInIcon />
                ) : (
                  <RingingOutIcon />
                )}
              </Avatar>
            }
            //action ={(props.voiceCtrl) && (props.state.Direction=='I') && (<React.Fragment><IconButton style={{padding:'10px'}}><Avatar style={{backgroundColor:'grey'}}><CallEndIcon style={{color:'white'}}/></Avatar></IconButton></React.Fragment>)}
            title={
              <Typography
                id="myAgentState"
                variant="h5"
                style={{ color: "white" }}
              >
                {t("agentstatus.ringing")}
                <Divider variant="fullWidth" className={classes.divider} />
              </Typography>
            }
            subheader={
              <>
                <Typography variant="body1" style={{ color: "white" }}>
                  Internal
                </Typography>
                <Typography variant="body1" style={{ color: "white" }}>
                  Duration 00:00:00
                </Typography>
              </>
            }
          />
        )) ||
        ((props.state.AgentState === agentStatuses.ACD_Busy ||
          props.state.AgentState === agentStatuses.ACD_Busy_Callback) && (
          <CardHeader
            avatar={
              <Avatar
                style={{
                  backgroundColor: "orange",
                  width: "55px",
                  height: "55px",
                  marginTop: "-10px",
                }}
              >
                <CheckIcon />
              </Avatar>
            }
            // action ={props.voiceCtrl && <React.Fragment><IconButton onClick={()=>{hangupCall()}} style={{padding:'10px'}}><Avatar style={{backgroundColor:'red'}}><CallEndIcon style={{color:'white'}}/></Avatar></IconButton></React.Fragment>}
            title={
              <Typography
                id="myAgentState"
                variant="h5"
                style={{ color: "white" }}
              >
                {t("agentstatus.connected")}
                <Divider variant="fullWidth" className={classes.divider} />
              </Typography>
            }
            subheader={
              <>
                <Typography variant="body1" style={{ color: "white" }}>
                  {props.groupCR.GroupName == null ||
                  props.groupCR.GroupName == ""
                    ? "Internal"
                    : props.groupCR.GroupName +
                      " " +
                      props.groupCR.CallerNumber}
                </Typography>
                <Typography variant="body1" style={{ color: "white" }}>
                  Duration <TimerComponent timerState={timerState} />
                </Typography>
              </>
            }
          />
        )) ||
        (props.state.AgentState === agentStatuses.Non_Acd_Busy && (
          <CardHeader
            avatar={
              <Avatar
                style={{
                  backgroundColor: "orange",
                  width: "55px",
                  height: "55px",
                  marginTop: "-10px",
                }}
              >
                <CheckIcon />
              </Avatar>
            }
            // action ={props.voiceCtrl && <React.Fragment><IconButton onClick={()=>{hangupCall()}} style={{padding:'10px'}}><Avatar style={{backgroundColor:'red'}}><CallEndIcon style={{color:'white'}}/></Avatar></IconButton></React.Fragment>}
            title={
              <Typography
                id="myAgentState"
                variant="h5"
                style={{ color: "white" }}
              >
                {t("agentstatus.connected")}
                <Divider variant="fullWidth" className={classes.divider} />
              </Typography>
            }
            subheader={
              <>
                <Typography variant="body1" style={{ color: "white" }}>
                  Internal
                </Typography>
                <Typography variant="body1" style={{ color: "white" }}>
                  Duration <TimerComponent timerState={timerState} />
                </Typography>
              </>
            }
          />
        )) || (
          <CardHeader
            avatar={
              <Avatar
                style={{
                  backgroundColor: "grey",
                  width: "55px",
                  height: "55px",
                  marginTop: "-10px",
                }}
              >
                <LineIcon />
              </Avatar>
            }
            title={
              <Typography variant="h5" style={{ color: "white" }}>
                {t("agentstatus.offline")}
                <Divider variant="fullWidth" className={classes.divider} />
              </Typography>
            }
            subheader={
              <>
                <Typography variant="body1" style={{ color: "white" }}>
                  {t("agentstatus.offline")}
                </Typography>
                <Typography variant="body1" style={{ color: "white" }}>
                  {t("agentstatus.offline")}
                </Typography>
              </>
            }
          />
        )}

      <CardContent></CardContent>
    </Card>
  );
}
